import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { SchoolsService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { CSchool } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-school-settings-main',
  templateUrl: './school-settings-main.component.html',
  styleUrls: ['./school-settings-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchoolSettingsMainComponent extends ChangableComponent implements OnInit {
  // DI
  public deviceService = inject(DeviceDetectorService);
  protected schoolService = inject(SchoolsService);

  private _school: CSchool;

  public ngOnInit(): void {
    this.schoolService.currentSchool$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (school) => {
        this.schoolService.setCurrentSchool(school);
        this._school = school;
        this.markForCheck();
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });
  }

  public get school(): CSchool {
    return this._school;
  }

  public save() {}
}
